import { AxiosResponse } from 'axios';
import { useAuth } from 'core/contexts';
import {
    withHeaders,
    instance as axiosInstance,
} from 'core/util/axiosInstance';
import { getDefaultHeaders } from 'core/util/other';
import { useQuery, UseQueryResult } from 'react-query';

const getUserGroupData = async (
    url: string,
    token: string
): Promise<AxiosResponse<any[], any>> => {
    const headers = getDefaultHeaders(token);
    const response = await axiosInstance().get(url, withHeaders(headers));
    return response;
};

export const useUserGroupList = (): UseQueryResult<
    AxiosResponse<any[], any>,
    unknown
> => {
    const { getToken } = useAuth();

    return useQuery('users', async () =>
        getUserGroupData('/metadata/usergroup', getToken())
    );
};
